import { answeredSortOptions } from "../Constants";
import { filterExpertAnsweredFilterData } from "../utils";
const initialState = {
    data:[],
    data2:[],
    pageNo:0,
    sortFilter:answeredSortOptions[0],
    sortChange:false,
    domains:[],
    isLoading:false,
    totalCount:0,
    refresh:'refreshed',
    reload:'random',
    searchQuery:'',
    sortOptions: answeredSortOptions,
    relevanceObj : {id:'9',value:"9",label:"Relevance", origValue:'relevance',sortOrder:''},
    curationCategory:'',
    isTransferred:false,
    sortOrder:'desc',
    expertAllFilters:[],
    curationStatus:'',
    seekerAttachments:[],
    isRelevance:false,
    expertCuration:[],
    expertDomain:[],
    isTransfered:false,
    

}

const answeredPageReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "updateAnsweredSearchedQuery":
      state = {...state, pageNo:0};
      state = {...state, data:[], data2:[]};
      state = {...state, searchQuery:payload};
      return state;
    case "updateAnsweredDomainValue":
      state = {...state, pageNo:0};
      state = {...state, data:[], data2:[]};
      state = {...state, sortChange:true};
      state = {...state, domains:payload};
      return state;
    case "updateAnsweredSortFilterValue":
      state = {...state, pageNo:0};
      state = {...state, data:[], data2:[]};
      state = {...state, sortChange:true};
      state ={...state, sortFilter:payload};
      return state;
    case 'reloadAnsweredtab':
      state = {...state, pageNo:0};
      state = {...state, data:[], data2:[]};
      state = {...state,reload:payload };
      return state;
    case 'IsLoadingAnsweredtab':
      state = {...state,isLoading:payload };
      return state;
    case 'updateAnsweredTabData':
      
      let newData = [];
      if(state.pageNo === 0){
        newData = payload.data;
      }else{
        newData = state.data.concat(payload.data);
      }
      state = {...state, totalCount:payload.count, data2:payload.data}
      state = {...state, data: payload.data};
      return state;
    case 'updatePageNoAnswered':
      if(payload === 0){
        state = {...state, data:[]};
      }
      state = {...state, pageNo:payload, data2:[]};
      state = {...state, sortChange:false};
      return state;
    case 'markedAnsweredData':
      state = {...state,data:payload };
      state = {...state, totalCount:state.totalCount-1}
      return state;
      case 'expertAnsweredFilter': {
        // payload is an array of {value,label,name} objects
        let mergedFilters;
      console.log("payload",payload)
        // if they clicked “Curated” (value==="0") we dispatch expertAnsweredFilter([])
        if (!payload || payload.length === 0) {
          // clear everything
          mergedFilters = [];
        } else {
          // append new ones onto existing, then dedupe by `value`
          mergedFilters = [...state.expertAllFilters, ...payload].reduce(
            (acc, curr) => {
              if (!acc.find(item => item.value === curr.value)) {
                acc.push(curr);
              }
              return acc;
            },
            []
          );
        }
      
        const curationCategory = filterExpertAnsweredFilterData(mergedFilters, 'curation')
          .map(obj => obj.value)
          .toString();
      
        const isTransferred = filterExpertAnsweredFilterData(mergedFilters, 'transfer').length > 0;
      
        return {
          ...state,
          data: [],
          pageNo: 0,
          curationCategory,
          isTransferred,
          domains: mergedFilters,
          expertAllFilters: mergedFilters
        };
      }
      
    // case 'expertAnsweredFilter':
    //   state = {...state, data:[]};
    //   state = {...state, pageNo:0};
    //   state = {...state, curationCategory: filterExpertAnsweredFilterData(payload,'curation').map(obj=>{
    //     return obj.value
    //   }).toString()}
    //   state = {...state, isTransferred:filterExpertAnsweredFilterData(payload,'transfer').length > 0? true: false};
    //   // state = {...state, domains:filterExpertAnsweredFilterData(payload,'domain')};
    //   state = {...state, domains:payload};
    //   state = {...state,expertAllFilters:payload };
    //   return state;
    case 'expertAnsweredSortFilter':
      state = {...state, data:[]};
      state = {...state, pageNo:0};
      state = {...state,sortOrder:payload }
      return state;
    case 'expertAnsweredCurationFilter':
      state = {...state, data:[]};
      state = {...state, pageNo:0};
      state = {...state,curationStatus:payload }
      return state;
    case "getSeekerAttachmentsInAnsweredTab":
      state = {...state, seekerAttachments:payload}
      return state;
    case "getIsRelevenceAT":
      state = {...state, isRelevance:payload}
      return state;
      case "expertCurationChange":
        state = {...state, expertCuration:payload}
        return state;
        case "expertDomainChange":
          state = {...state, expertDomain:payload}
          return state;
          case "changeTransfered":
            state = {...state, isTransfered:payload}
            return state;
            case "changeCurationStatus":
              state = {...state, curationStatus:payload}
              return state;
  default:
    return state
  }
}

export default answeredPageReducer;
// expertCurationChange
// changeCurationStatus
// changeTransfered